<template>
  <div class="w-full flex flex-row">
    <div class="w-full h-[44px] md:h-[72px] mx-4 my-10 md:my-6 px-2 md:px-7 flex flex-row justify-between">
      <div class="w-full flex flex-row gap-4 items-center">
        <RouterLink :to="{ name: 'home' }">
          <img class="h-[44px] md:h-[72px]" src="@/assets/images/logo.webp" />
        </RouterLink>
        <div class="flex-grow">
          &nbsp;
        </div>
        <div v-if="userStore.user">
          {{ userStore.user.nickname }}
        </div>
        <VaButton v-if="!userStore.isLoggedIn" :to="{ name: 'login' }" size="large" plain>
          {{ t('header.login') }}
        </VaButton>
        <VaButton v-if="!userStore.isLoggedIn" :to="{ name: 'register' }" size="large" preset="secondary" color="primary" border-color="primary">
          {{ t('header.register') }}
        </VaButton>
        <VaButton
          v-if="userStore.isLoggedIn"
          size="large"
          preset="secondary"
          icon="menu"
          @click="userStore.showSidebar"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaButton } from 'vuestic-ui'
import { useUserStore } from '@/stores/UserStore'

const userStore = useUserStore()
const { t } = useI18n()
</script>
